import { Component } from 'react';

class SpellsCheck extends Component {
	render() {
		return '';
	}
}

export default SpellsCheck;
